import { BaseEntityPage } from '../../components/common';
import { FacultiesContent } from './components';

export default function FacultiesPage() {
	return (
		<BaseEntityPage ContentComponent={FacultiesContent} />
	);
}